import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Divider, List, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core'
import { ExitToApp } from '@material-ui/icons'
import uuid from 'uuid/v4'
import Context from '../../../context'
import { getUserScreensList, logout } from '../../../services/auth'

import SideBarIcon from '../SideBarIcon'
import './styles.scss'

function SideBarListItems() {
  const { screenList, setScreenList } = useContext(Context)
  const { aboutCurrentPage, setAboutCurrentPage } = useContext(Context)
  const { openSideBar, setOpenSideBar } = useContext(Context)
  const [pagesList, setPagesList] = useState([])
  const pageName = PageName()

  useEffect(() => {
    setScreenList(getUserScreensList)
  }, [])

  useEffect(() => {
    if (screenList.length > 0) {
      const newArr = screenList.map(screen => {
        const { SystemScreen } = screen
        return { ...SystemScreen }
      })

      const filteredList = newArr.filter(screen => {
        return screen.isInMenu
      })

      setPagesList(filteredList)
    }
  }, [screenList])

  function PageName() {
    const location = useLocation()
    return location.pathname
  }

  return (
    <List className="c-menu-list">
      {pagesList.map(page => (
        <li
          className={`c-menu-list__item ${PageName() === page.path ? 'active' : ''}`}
          key={uuid()}
        >
          <Tooltip disableHoverListener={!!openSideBar} title={page.name} placement="right" arrow>
            <Link className="c-menu-list__link" button key={page.id} to={`${page.path}`}>
              <SideBarIcon className="c-menu-list__icon" menuName={page.name} />
              <ListItemText className="c-menu-list__text" disableTypography primary={page.name} />
            </Link>
          </Tooltip>
        </li>
      ))}
      <Divider />
      <li className="c-menu-list__item">
        <Tooltip disableHoverListener={openSideBar} title="Sair" placement="right" arrow>
          <a
            href="#"
            className="c-menu-list__link"
            onClick={() => {
              logout()
            }}
          >
            <ListItemIcon className="c-menu-list__icon">
              <ExitToApp />
            </ListItemIcon>
            <ListItemText disableTypography className="c-menu-list__text">
              Sair
            </ListItemText>
          </a>
        </Tooltip>
      </li>
    </List>
  )
}

export default SideBarListItems
